import $ from 'jquery';

async function initializeHighcharts() {
  if ($('#RevenueChart').length !== 1) {
    return;
  }

  const {
    Highcharts,
    ListingsChart,
  } = await

  import(/* webpackChunkName: 'listingschart' */'../modules/listing-chart');

  let RevenueChart = null;
  let TrafficChart = null;

  TrafficChart = new ListingsChart($('#TrafficChart'), {
    chart: {
      type: 'area',
      backgroundColor: null,
      events: {
        load() {
          if (typeof RevenueChart.chart.getChartObject() === 'undefined') {
            return;
          }

          const RevenueChartObject = RevenueChart.chart.getChartObject();
          const xData = RevenueChartObject.series[0].xData;
          const yData = RevenueChartObject.series[0].yData;
          addPlotBandsAndMarkers(xData, yData, this);
        },
      },
    },
    tooltip: {
      pointFormatter() {
        return `<b>${Highcharts.numberFormat(this.y, 0, '.', ',')}</b>`;
      },
    },
  });

  RevenueChart = new ListingsChart($('#RevenueChart'), {
    chart: {
      type: 'area',
      backgroundColor: null,
      events: {
        load() {
          const xData = this.series[0].xData;
          const yData = this.series[0].yData;
          addPlotBandsAndMarkers(xData, yData, this);

          if (typeof TrafficChart.chart.getChartObject() !== 'undefined') {
            addPlotBandsAndMarkers(xData, yData, TrafficChart.chart.getChartObject());
          }

        },
      },
    },
    yAxis: {
      labels: {
        formatter() {
          if (this.value < 0) {
            this.value *= -1;
            return `-$${this.axis.defaultLabelFormatter.call(this)}`;
          }

          return `$${this.axis.defaultLabelFormatter.call(this)}`;
        },
      },
    },
    tooltip: {
      pointFormatter() {
        if (this.y < 0) {
          return `<b>-$${Highcharts.numberFormat(this.y * -1, 2, '.', ',')}</b>`;
        }
        return `<b>$${Highcharts.numberFormat(this.y, 2, '.', ',')}</b>`;
      },
    },
  });

  function addPlotBandsAndMarkers(xData, yData, chart) {
    const INACTIVE_THRESHOLD = 3;
    let firstZeroMonth = yData.length - 1;
    while (yData[firstZeroMonth] === 0) {
      firstZeroMonth--;
    }

    firstZeroMonth++;

    const bandOptions = {
      from: xData[firstZeroMonth],
      to: xData[xData.length - 1],
      color: '#f7f7f7',
      label: {
        style: {
          color: '#637381',
        },
        useHTML: true,
        className: 'heading--5',
        verticalAlign: 'middle',
        rotation: 270,
        text: 'Store inactive',
      },
      id: 'plot-band-inactive',
    };

    const markerOptions = {
      series: [{
        zoneAxis: 'x',
        zones: [{
          value: xData[firstZeroMonth],
        }, {
          value: xData[xData.length],
          color: '#999999',
        }],
      }],
    };

    if ((yData.length - firstZeroMonth) < INACTIVE_THRESHOLD) {
      return;
    }

    chart.update(markerOptions);
    chart.xAxis[0].addPlotBand(bandOptions);
  }
}

export default initializeHighcharts;
